import { useState } from 'react'

import styles from './ExerciseRow.module.css'
import { parseRest } from '../../../hooks'

function summarize(sets) {
  return sets
    .map((s) => [s.w && `${s.w} kg`, s.r && `${s.r}`].filter(Boolean).join(' × '))
    .filter(Boolean)
    .join(' · ')
}

const ExerciseRow = ({ exercise, entry, hydrated, onToggle, onSetValue, last, onStartRest }) => {
  const [open, setOpen] = useState(false)
  const { name, sets, reps, rest, note, video } = exercise
  const done = hydrated && entry.done
  const logged = hydrated ? entry.sets.filter((s) => s && (s.w || s.r)).length : 0

  return (
    <div className={`${styles.row} ${done ? styles.done : ''}`}>
      <button
        type="button"
        className={styles.check}
        onClick={onToggle}
        aria-pressed={done}
        aria-label={done ? `Desmarcar ${name}` : `Marcar ${name} como hecho`}
      >
        <span aria-hidden="true">✓</span>
      </button>

      <div className={styles.body}>
        <div className={styles.head}>
          <a className={styles.name} href={video} target="_blank" rel="noopener noreferrer">
            {name}
          </a>
          <span className={styles.prescription}>
            {sets} × {reps}
          </span>
          <span className={styles.rest}>{rest}</span>
        </div>

        {note && <p className={styles.note}>{note}</p>}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.action}
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
          >
            {open ? 'Ocultar cargas' : 'Registrar cargas'}
            {!open && logged > 0 && <span className={styles.badge}>{logged}</span>}
          </button>
          <button
            type="button"
            className={styles.action}
            onClick={() => onStartRest(parseRest(rest), name)}
          >
            ⏱ Descanso
          </button>
          {last && (
            <span className={styles.last}>
              Última vez ({last.daysAgo} d): <b>{summarize(last.sets)}</b>
            </span>
          )}
        </div>

        {open && (
          <div className={styles.log}>
            {Array.from({ length: sets }).map((_, i) => {
              const set = entry.sets[i] || { w: '', r: '' }
              const previous = last?.sets?.[i]
              return (
                <div className={styles.set} key={i}>
                  <span className={styles.setNum}>{i + 1}</span>
                  <label className={styles.field}>
                    <input
                      type="text"
                      inputMode="decimal"
                      value={set.w}
                      placeholder={previous?.w || 'kg'}
                      onChange={(e) => onSetValue(i, 'w', e.target.value)}
                      aria-label={`Peso serie ${i + 1} de ${name}`}
                    />
                    <span>kg</span>
                  </label>
                  <label className={styles.field}>
                    <input
                      type="text"
                      inputMode="numeric"
                      value={set.r}
                      placeholder={previous?.r || reps}
                      onChange={(e) => onSetValue(i, 'r', e.target.value)}
                      aria-label={`Repeticiones serie ${i + 1} de ${name}`}
                    />
                    <span>reps</span>
                  </label>
                </div>
              )
            })}
            <p className={styles.hint}>
              Los grises son los de la última vez. Iguala o supera el tope de reps en todas las
              series y sube 2.5–5 kg la próxima.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ExerciseRow
